import { render, staticRenderFns } from "./GSelectBox.vue?vue&type=template&id=5916f114&scoped=true&"
import script from "./GSelectBox.vue?vue&type=script&lang=ts&"
export * from "./GSelectBox.vue?vue&type=script&lang=ts&"
import style0 from "./GSelectBox.vue?vue&type=style&index=0&id=5916f114&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5916f114",
  null
  
)

export default component.exports